import React, {useReducer} from 'react';
import {MaintenanceContext, MaintenanceDispatchContext} from './contexts';
import type {MaintenanceState, MaintenanceActions} from './types.js';

interface MaintenanceProviderProps {
  children: React.ReactElement;
}

function reducer(state: MaintenanceState, action: MaintenanceActions) {
  if (action.type === 'SET_ACTIVE_VIEW') {
    return {
      ...state,
      activeView: action.payload,
    };
  }

  return state;
  // throw new Error('Unknown action: ' + action.type);
}

const initialState: MaintenanceState = {
  activeView: 'list',
};

const MaintenanceProvider = ({children}: MaintenanceProviderProps) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <MaintenanceContext.Provider value={state}>
      <MaintenanceDispatchContext.Provider value={dispatch}>
        {children}
      </MaintenanceDispatchContext.Provider>
    </MaintenanceContext.Provider>
  );
};

export default MaintenanceProvider;
